
<template>
  <span
    :class="[
      'px-2 py-1 text-xs font-semibold rounded-full',
      priorityClasses
    ]"
  >
    {{ priority }}
  </span>
</template>

<script setup lang="ts">
import { TicketPriority } from '@/types/custom-ticket-types';

const props = defineProps<{
  priority: TicketPriority | string
}>();

const priorityClasses = computed(() => {
  switch (props.priority) {
  case TicketPriority.Low:
  case 'LOW':
    return 'bg-gray-100 text-gray-600';
  case TicketPriority.Medium:
  case 'MEDIUM':
    return 'bg-blue-100 text-blue-600';
  case TicketPriority.High:
  case 'HIGH':
    return 'bg-orange-100 text-orange-600';
  case TicketPriority.Urgent:
  case 'URGENT':
    return 'bg-red-100 text-red-600';
  default:
    return 'bg-gray-100 text-gray-600';
  }
});
</script>
